import { createSlice } from '@reduxjs/toolkit'

import type { PayloadAction } from '@reduxjs/toolkit'

export interface AppError {
  description: string
  isFatal: boolean
  event_id?: string
}

interface AppState {
  error: AppError | null
  isUserAuthenticated: boolean
}

const initialState: AppState = {
  error: null,
  isUserAuthenticated: true
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setAppError: (state, action: PayloadAction<AppError>) => {
      state.error = action.payload
    },
    clearAppError: (state) => {
      state.error = null
    },
    setUserAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isUserAuthenticated = action.payload
    }
  }
})

export const { setAppError, clearAppError, setUserAuthenticated } = appSlice.actions
export default appSlice.reducer
